import { Box, Column, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { DashboardCard } from '~/components/shared/DashboardCard';

interface IButtonContainerProps {
  variant: 'teal' | 'green';
  title: string;
  description: string;
  ButtonComponent: React.ReactNode;
  FooterComponent?: React.ReactNode;
  disabled?: boolean;
  showNewBadge?: boolean;
}

const variantStyles = {
  teal: {
    background: 'linear-gradient(135deg, #2A6C7E 0%, #2F7A8D 50%, #348A9E 100%)',
  },
  green: {
    background: 'linear-gradient(135deg, #028A7E 0%, #01D1BB 100%)',
  },
};

// diagonal corner badge positioning — no DS badge-corner component
const newBadgePositionStyle: React.CSSProperties = {
  position: 'absolute',
  top: 14,
  right: 4,
  transform: 'rotate(46.71deg)',
  transformOrigin: 'center',
};

const NewBadge = () => (
  <Box style={{ position: 'absolute', top: 0, right: 0, width: 'auto', overflow: 'visible' }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="57"
      height="60"
      viewBox="0 0 57 60"
      fill="none"
    >
      <path
        d="M31.9971 0C45.8042 0 56.9971 11.1929 56.9971 25V59.9971L0 0H31.9971Z"
        fill="#51D2DB"
      />
    </svg>
    <Typography
      as="span"
      bold
      uppercase
      size="caption"
      color={colors.shades['0']}
      style={newBadgePositionStyle}
    >
      NEW
    </Typography>
  </Box>
);

export const ButtonContainer = ({
  variant,
  title,
  description,
  ButtonComponent,
  FooterComponent,
  disabled,
  showNewBadge = false,
}: IButtonContainerProps) => {
  const styles = variantStyles[variant];

  return (
    <DashboardCard
      style={{
        background: styles.background,
        flex: 1,
        opacity: disabled ? 0.7 : 1,
        position: 'relative',
      }}
    >
      <Column gap={1} px={6} pt={5} pb={6}>
        {showNewBadge && <NewBadge />}
        <Typography size="heading_3" bold color={colors.shades['0']}>
          {title}
        </Typography>
        <Row align="start" justify="between" gap={4}>
          <Typography color={colors.shades['0']} style={{ flex: 1 }}>
            {description}
          </Typography>
          {ButtonComponent}
        </Row>
      </Column>
      {FooterComponent}
    </DashboardCard>
  );
};
